export default function handleNavigation() {
    const navOpenClass = 'nav-active';

    $('body').on('click', '.js-open-navigation', () => {
        $('body').addClass(navOpenClass);
        return false;
    }).on('click', '.js-close-navigation', () => {
        $('body').removeClass(navOpenClass);
        return false;
    });
}